import { z } from 'zod';

export const IMPORT_MODES = ['check', 'import'] as const;
export const MAX_IMPORT_FILES = 50;
export const MAX_IMPORT_FILE_BYTES = 5 * 1024 * 1024;
export const MAX_IMPORT_BATCH_ROWS = 1_000;

export const importQuerySchema = z.object({
  mode: z.enum(IMPORT_MODES),
  images: z.stringbool().default(true),
});

export const importRowErrorSchema = z.object({
  file: z.string(),
  row: z.int().min(2),
  messages: z.array(z.string()).min(1),
});

export const importDuplicateSchema = z.object({
  file: z.string(),
  row: z.int().min(2),
  existingId: z.uuid().nullable(),
  firstFile: z.string().nullable(),
  firstRow: z.int().min(2).nullable(),
});

export const importResultSchema = z.object({
  mode: z.enum(IMPORT_MODES),
  rows: z.int().min(0),
  ready: z.int().min(0),
  errors: z.array(importRowErrorSchema),
  duplicates: z.array(importDuplicateSchema),
  imported: z.int().min(0),
  images: z.int().min(0),
});

export type ImportMode = (typeof IMPORT_MODES)[number];
export type ImportRowError = z.infer<typeof importRowErrorSchema>;
export type ImportDuplicate = z.infer<typeof importDuplicateSchema>;
export type ImportResult = z.infer<typeof importResultSchema>;
